module.exports = __webpack_public_path__ + "img/kala.60ca5b7f.jpg";